/** The bits of window.Telegram.WebApp we use. The official script is loaded from index.html. */
export interface TgWebApp {
  initData: string;
  initDataUnsafe: { user?: { id: number; first_name: string; language_code?: string }; start_param?: string };
  version: string;
  platform: string;
  colorScheme: 'light' | 'dark';
  ready(): void;
  expand(): void;
  openTelegramLink(url: string): void;
  openLink(url: string, options?: { try_instant_view?: boolean }): void;
  /** Telegram Stars checkout for an invoice link created by the bot. */
  openInvoice?(url: string, callback: (status: 'paid' | 'cancelled' | 'failed' | 'pending') => void): void;
  setHeaderColor?(color: string): void;
  setBackgroundColor?(color: string): void;
  disableVerticalSwipes?(): void;
  HapticFeedback?: {
    impactOccurred(style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft'): void;
    notificationOccurred(type: 'error' | 'success' | 'warning'): void;
    selectionChanged(): void;
  };
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TgWebApp };
  }
}

export function tgWebApp(): TgWebApp | null {
  const wa = window.Telegram?.WebApp;
  // Outside Telegram the script still defines WebApp with empty initData.
  return wa && wa.initData ? wa : null;
}

export const haptic = {
  light(): void {
    tgWebApp()?.HapticFeedback?.impactOccurred('light');
  },
  medium(): void {
    tgWebApp()?.HapticFeedback?.impactOccurred('medium');
  },
  error(): void {
    tgWebApp()?.HapticFeedback?.notificationOccurred('error');
  },
  success(): void {
    tgWebApp()?.HapticFeedback?.notificationOccurred('success');
  },
};
